import FSMState from '@src/slide/infrastructure/module/independent/state-machine/fsm-state';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import WhiteScreenCollector from '@src/slide/infrastructure/module/dependent/performance/white-screen/white-screen-collector';
import ArkLoader from '@src/js/common/ark-extensions';
import { BOOT_STATE_TYPE } from '@src/js/service/boot-service/boot-manager.interface';
import { initScriptLoader } from '@src/js/common/utils';
import { getDocInfo, transformDocInfo } from '@src/framework/workbench/ui/titlebar/api';
import { IEditorAppServices } from '@src/slide/application/entry/toc/editor/base/base-editor-app-service.interface';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import createHTMLViewportOffsetObserve from '@src/slide/infrastructure/module/dependent/html-viewport-offset-observer';
import { onSlideAppReady, SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';
import { OnlineEditServices } from '@src/slide/domain/slide-app/scenes/online/core/online-edit-services.core';
import ENV from '@src/slide/infrastructure/module/dependent/runtime-environment/enviroment';
import { ConnectionController } from '@tencent/docs-connection';
import { IEditorLifeCycleService, LifeCycleType } from '@src/slide/application/service/editor-lifecycle/core/interface';
import { shouldDisableSocket } from '@src/slide/infrastructure/module/dependent/socket';
import eventBus, { EventKeys } from '@src/slide/infrastructure/module/independent/event-emitter/instance';

declare global {
    interface Window {
        $: any;
        hostname: string;
        SLR: any;
    }
}

export default class PcInfrastructureReadyState extends FSMState {
    private static deprecatedImportJQueryDoNotUseOrYouWillBeFired() {
        return import('jquery');
    }
    private mountJqueryRetryCount = 0;

    public constructor() {
        super(BOOT_STATE_TYPE.infrastructureDidReady);
    }

    public enterCallback() {
        // 重置计时器
        this.duration = 0;

        // 开启白屏监控
        WhiteScreenCollector.getInstance().startWhiteScreenMonitor();
        // 生命周期回调
        this.getLifecycleService()?.emitEvent(LifeCycleType.INFRASTRUCTURE_DID_READY);
        this.deprecatedMountJQuery();

        SlideDataServices.DocInfoManager.promise()
            .then((service) => {
                service.waitForReady((docInfo) => {
                    if (docInfo.doc_meta) {
                        window.clientVars.docInfo = transformDocInfo(docInfo);
                    }
                });
            });

        onSlideAppReady(async () => {
            const connectionInstance = !(ENV.IS_LOCAL_EDIT || shouldDisableSocket())
                ? (() => {
                    OnlineEditServices.CollaborationManager.promise()
                        .then(c => c.getSocket().connectionInstance)
                        .then(ArkLoader.setConnectionController);
                    return new ConnectionController({} as any);
                })()
                : new ConnectionController({} as any);
            initScriptLoader();
            // ark loader 初始化
            ArkLoader.init(connectionInstance);
            // 生命周期回调
            this.getLifecycleService()?.emitEvent(LifeCycleType.DATA_READY);
        });

        eventBus.on(EventKeys.VISIBLE_PAGE_DISPLAY, () => {
            if (window.SLR?.assetLoaded) {
                window.SLR.load('PageFunnelReport', (PageFunnelReport) => {
                    PageFunnelReport?.init?.();
                });
            } else {
                window.SLR?.listen('SL-INIT', () => {
                    window.SLR.load('PageFunnelReport', (PageFunnelReport) => {
                        PageFunnelReport?.init?.();
                    });
                });
            }
        });

        this.getUpdateNoticeManager().init();  // 初始化更新通知

        createHTMLViewportOffsetObserve();
    }

    private getLifecycleService(): IEditorLifeCycleService | undefined {
        const app =  AppServiceProvider.getInstance().getAppServices() as IEditorAppServices;
        return app?.viewableServiceLayer.lifeCycleService;
    }

    private getUpdateNoticeManager() {
        const appServices = AppServiceProvider.getInstance().getAppServices() as IEditorAppServices;
        return appServices.viewableServiceLayer.updateNoticeManager;
    }

    /**
     * assets.v11中很多地方都使用了jquery
     */
    private async deprecatedMountJQuery() {
        try {
            // TODO: 完全去掉 jquery 的依赖，依赖 jQuery 的组件包括：水印 ($.ajax)，会议 (wemeet) ... @rongodzhang
            window.$ = await PcInfrastructureReadyState.deprecatedImportJQueryDoNotUseOrYouWillBeFired();
        } catch (error) {
            window.log.error('jquery mountfail', error);

            tdw({
                opername: 'quality_slide',
                module: 'feature',
                action: 'jquery_load_fail',
            });

            // retry
            if (this.mountJqueryRetryCount < 3) {
                this.mountJqueryRetryCount += 1;
                await this.deprecatedMountJQuery();
            }
        }
    }
}
